export default "__VITE_ASSET__Bpaf$nEt__"